import { useState, useEffect, useRef } from "react";
import general from "../../general";
import { useToggle, useLocalStorageState } from "ahooks";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { url } from "../../config";
import { Link, useHistory } from "react-router-dom";
import useActiveState from "../../lib/useActiveState";
import Dialog from "../../lib/Dialog";
import { useLogin } from "../../lib/LoginContext";

// 账号、密码登录
export default () => {
  const history = useHistory();
  const { aplus_queue } = window;

  const { setShowLogin, setIsFromLogin, setPswEditShow, setRegisterShow } =
    useLogin();

  const [datas, setDatas] = useLocalStorageState("users", {
    defaultValue: [],
  });

  const [isPlaintext, { toggle: toggleIsPlaintext }] = useToggle(true);
  const [data, setData] = useState(
    datas.length > 0 ? { ...datas[0] } : { username: "", password: "" }
  );
  const [agreement, setAgreement] = useState(false);
  const [loging, setLoging] = useState(false);
  const [config, setConfig] = useActiveState("config");

  let timer = null;
  const login = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      loginCode();
    }, 500);
  };

  const loginCode = async () => {
    if (!data.username) {
      Dialog.error("请输入用户名");
      return;
    }

    if (!data.password) {
      Dialog.error("请输入密码");
      return;
    }

    if (!agreement) {
      Dialog.error(
        <div>
          登录前请阅读并同意
          <br />
          以下用户协议和隐私政策
        </div>
      );
      return;
    }

    if (loging) {
      return;
    }

    setLoging(true);
    Dialog.loading();

    await general.axios
      .post("/v3/user/user/loginGrpc", data)
      .finally(() => {
        setLoging(false);
        Dialog.close();
      })
      .then(async (res) => {
        let { status, data: result } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          localStorage.setItem("user_id", result.user_id);
          localStorage.setItem("password", data.password);
          localStorage.setItem("token", result.token);
          let tmp = datas.filter((item) => item.username !== data.username);
          tmp.unshift(data);
          setDatas(tmp);
          aplus_queue.push({
            action: "aplus.record",
            arguments: [
              "login",
              "login",
              {
                agent: localStorage.getItem("agent"),
                username: data.username,
              },
            ],
          });

          Dialog.info("登录成功");

          await getUserInfo();
          await getPopup();

          setShowLogin(false);
          document.body.style.overflow = "";

          // 是老用户  并且为新人福利登录 返回首页
          if (
            result.is_new_user === 0 &&
            sessionStorage.getItem("isHaveBack")
          ) {
            history.replace("/");
            window.location.reload();
          } else {
            window.location.reload();
          }
        }
      })
      .catch((err) => {
        if (err) {
          Dialog.error("login " + err.message);
        } else {
          Dialog.error("登录失败，请稍后重试");
        }
      });
  };

  const getUserInfo = async () => {
    await general.axios
      .post("/v3/user/user/getMemberInfo")
      .then((res) => {
        let { status, data } = res.data;
        if (!status.succeed) {
          if (status.error_code == 1016) {
            localStorage.removeItem("user_id");
            localStorage.removeItem("username");
            localStorage.removeItem("password");
            localStorage.removeItem("token");
          } else {
            Dialog.error(status.error_desc);
          }
        } else {
          localStorage.setItem("username", data.member_info.member_name);
        }
      })
      .catch((error) => {
        Dialog.error(error.message);
      });
  };

  const getPopup = async () => {
    await general.axios
      .post("/v3/movable/popup/popup")
      .then(({ data: resData }) => {
        console.log("右下角悬浮球--------", resData);
        let { status, data } = resData;
        if (status.succeed) {
          sessionStorage.setItem(
            "popupData",
            JSON.stringify({
              ...data,
              route: data?.jump_value,
            })
          );
        }
      });
  };

  let clickCount = 0;
  const [showSelect, setShowSelect] = useState(false);
  const selectRef = useRef(null);
  const downButtonRef = useRef(null);

  // 点击外部区域关闭select-box
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showSelect &&
        selectRef.current &&
        !selectRef.current.contains(event.target) &&
        downButtonRef.current &&
        !downButtonRef.current.contains(event.target)
      ) {
        setShowSelect(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSelect]);

  return (
    <div className="account-phonelogin account-login">
      <div className="phonelogin-body body">
        <div className="input">
          <div className="input-content">
            <input
              name="username"
              type="text"
              value={data.username}
              placeholder="请输入用户名"
              autoComplete="off"
              onChange={(e) => setData({ ...data, username: e.target.value })}
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>
                  );
                  clickCount = 0;
                }
              }}
            />

            {data.username ? (
              <CloseCircleOutlined
                className="clear"
                style={{ marginRight: datas.length > 0 ? "12px" : 0 }}
                onClick={() => setData({ ...data, username: "" })}
              />
            ) : null}

            {datas.length > 0 && (
              <div
                ref={downButtonRef}
                className="assist select"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  setShowSelect(!showSelect);
                }}
              >
                <img src="/resources/account/down.png" className="select" />
              </div>
            )}
          </div>

          {showSelect && (
            <div ref={selectRef} className="select-box">
              <div
                className="select-item"
                onClick={() => {
                  setData({ username: "", password: "" });
                  setShowSelect(false);
                }}
              >
                手动输入
              </div>
              {datas.map((item, index) => (
                <div
                  className={`select-item ${
                    data.username == item.username ? "active" : ""
                  }`}
                  key={index}
                  onClick={() => {
                    setData({ ...item });
                    setShowSelect(false);
                  }}
                >
                  {item.username}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="input code">
          <div className="input-content">
            <input
              name="password"
              type={isPlaintext ? "password" : "text"}
              value={data.password}
              placeholder="请输入密码"
              onChange={(e) => setData({ ...data, password: e.target.value })}
              onMouseDown={() => {
                clickCount++;
                if (clickCount > 2) {
                  Dialog.info(
                    <div>
                      若遇到iOS系统键盘问题，请
                      <br />
                      重启手机或我的-&gt;联系客服
                    </div>
                  );
                  clickCount = 0;
                }
              }}
            />

            {data.password ? (
              <CloseCircleOutlined
                className="clear"
                onClick={() => setData((data) => ({ ...data, password: "" }))}
              />
            ) : null}

            <div className="psw-eye" onClick={() => toggleIsPlaintext()}>
              {isPlaintext ? (
                <img src="/resources/account/show.png" />
              ) : (
                <img src="/resources/account/hidden.png" />
              )}
            </div>
          </div>
        </div>

        <div className="operate">
          {config.is_quick_register ? (
            <>
              <div
                className="item"
                onClick={() => {
                  document.body.style.overflow = "hidden";
                  setPswEditShow(true);
                }}
              >
                忘记密码？
              </div>
              <div
                className="item"
                onClick={() => {
                  document.body.style.overflow = "hidden";
                  setRegisterShow(true);
                }}
              >
                快速注册
              </div>
            </>
          ) : (
            <Link to="/forget">忘记密码？</Link>
          )}
        </div>

        <div className={"btn " + (loging ? "disable" : "")} onClick={login}>
          登录
        </div>
      </div>

      <div className="account-agreement" style={{ marginTop: "67px" }}>
        {agreement ? (
          <CheckCircleOutlined className="checked" />
        ) : (
          <div className="unchecked" onClick={() => setAgreement(true)}></div>
        )}
        我已阅读并同意
        <div
          className="agreement-link"
          onClick={() => {
            setIsFromLogin(true);

            setTimeout(() => {
              history.push(
                "/iframe?url=" + url + "/userAgreement&title=用户协议"
              );
            }, 100);
          }}
        >
          《用户协议》
        </div>
        、
        <div
          className="agreement-link"
          onClick={() => {
            setIsFromLogin(true);

            setTimeout(() => {
              history.push(
                "/iframe?url=" + url + "/privacyPolicy&title=隐私政策"
              );
            }, 100);
          }}
        >
          《隐私政策》
        </div>
      </div>
    </div>
  );
};
